export enum CleverTapEventType {
  SCREEN_EVENT = "screen_view",
}
export const ACTIONS = {
  mf_serv_card_cta_click: "mf_serv_card_cta_click",
  mf_serv_secure_health_cta_click: "mf_serv_secure_health_cta_click",
  mf_serv_quick_actions_drawer_click: "mf_serv_quick_actions_drawer_click",
  mf_serv_quick_actions_option_select: "mf_serv_quick_actions_option_select",
  mf_serv_transact_option_select: "mf_serv_transact_option_select",
  mf_serv_my_statement_option_select: "mf_serv_my_statement_option_select",
  mf_serv_statement_form_field: "mf_serv_statement_form_field",
  mf_serv_statement_form_submit: "mf_serv_statement_form_submit",
  mf_serv_download_format_select: "mf_serv_download_format_select",
  get_help_cta_click: "get_help_cta_click",
  get_help_additional_cta_click: "get_help_additional_cta_click",
  get_help_faq_cat_click: "get_help_faq_cat_click",
  get_help_faq_sub_cat_click: "get_help_faq_sub_cat_click",
  back_click: "back_click",
  custom_screenview: "custom_screenview",
};

interface WorkflowInfo {
  [key: string]: any;
}
export const MF_QuickActions_CleverTap: WorkflowInfo = {
  key: ACTIONS.mf_serv_quick_actions_option_select,
  title: "quick_actions",
  values: {
    Transact: "transact",
    "My Statements": "my_statements",
    "Link/Delink folios": "link/delink_folios",
    "Go to ABSLMF Portal": "go_to_abslmf_portal",
  },
  transact: {
    key: ACTIONS.mf_serv_transact_option_select,
    title: "transact",
    values: {
      Redeem: "redeem",
      SWP: "swp",
      Switch: "switch",
      STP: "stp",
      "Pause/ cancel SIP": "pause/cancel_sip",
    },
  },
  my_statements: {
    key: ACTIONS.mf_serv_my_statement_option_select,
    title: "my_statements",
    values: {
      "Account statement": "account_statement",
      "Capital gain statement": "capital_gain_statement",
      "Exit load": "exit_load",
      "Transaction statement": "transaction_statement",
    },
  },
};
